module.exports = __webpack_public_path__ + "img/Groupe 526.823c239d.svg";